import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { AISuggestionNode, GeneratePrompt } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Props {
  articleId: string
  layerId: string
}

export interface Data {
  node: AISuggestionNode
}

export interface Selection {
  type: 'all' | 'text' | 'node'
  anchor?: number
  head?: number
}

export interface Variables {
  prompt: GeneratePrompt
  selection?: { [key: string]: any }
  documentAsMarkdown?: string
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const createAISuggestionNode = async ({ articleId, layerId, ...variables }: Variables & Props) => {
  const { documentAsMarkdown: document_as_markdown, ...rest } = variables
  const response = await sendToApi<Data>(`/articles/${articleId}/layers/${layerId}/ai_suggestion_nodes`, {
    method: 'POST',
    body: {
      document_as_markdown,
      ...rest,
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response
}

export const useCreateAISuggestionNode = (props: Props, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    'createAISuggestionNode',
    async (variables) => {
      const response = await createAISuggestionNode({ ...props, ...variables })
      return response.data
    },
    {
      ...options,
    },
  )
}
